import { render, staticRenderFns } from "./data-permissions.vue?vue&type=template&id=f7b9282a&scoped=true"
import script from "./data-permissions.vue?vue&type=script&lang=js"
export * from "./data-permissions.vue?vue&type=script&lang=js"
import style0 from "./data-permissions.vue?vue&type=style&index=0&id=f7b9282a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b9282a",
  null
  
)

export default component.exports